<template>
  <section v-if="sponsors.length">
    <div class="partner">
      <h2 class="partner-title"><strong>Patrocinador</strong> Oficial</h2>
      <div class="partner-logos">
        <img
          v-for="(sponsor, index) in sponsors"
          :key="index"
          :src="sponsor.image"
          :alt="sponsor.name"/>
      </div>
    </div>
  </section>
</template>

<script>
import api from '@/api';

export default {
  name: 'SponsorComponent',
  props: {
  },
  data() {
    return {
      sponsors: [],
      // intersectionObserver: null,
      // visible: true,
    }
  },
  methods: {
    // isVisible(val) {
    //   this.visible = val[0].isIntersecting
    // },
  },
  async mounted() {
    try {
      this.sponsors = await api.sponsors.all()
    } catch(e) {
      console.log(e)
    }
    // this.intersectionObserver = new IntersectionObserver(this.isVisible, {
    //   root: null,
    //   rootMargin: "0px",
    //   threshold: 0.5,
    // })
    // this.intersectionObserver.observe(this.$el)
  },
  unmounted() {
    // this.intersectionObserver.disconnect()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/assets/scss/colors';
@import '@/assets/scss/queries';
@import '@/assets/scss/fonts';
$padding: 200px;

section {
  --sponsors-card-logo-width: calc(var(--content-width) * .075);
  --sponsors-card-margin: 0 auto -2rem;
  --sponsors-card-padding: 2rem;
  --sponsors-card-title-size: .9rem;
  --sponsors-card-title-margin: 0 0 .5rem;
  --sponsors-card-width: var(--content-width);
  --sponsors-padding: 0 0 4rem;

  @include media(sm) {
    --sponsors-card-margin: 0 auto -6rem;
    --sponsors-card-padding: 4rem 4rem 8rem;
    --sponsors-card-title-size: 1.5rem;
    --sponsors-card-title-margin: 0 0 4rem;
    --sponsors-card-width: calc(
      var(--content-width) - var(--side-padding) - var(--content-width) * .075
        );
    --sponsors-padding: 6rem 0;
  }

  z-index: calc(var(--z-footer) + 1);
  position: relative;
  background-image: url('../assets/images/sponsor-bg-big.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: bottom;
  margin-bottom: -3rem;
  transition: .5s opacity ease-out;

  padding: var(--sponsors-padding);

  &.invisible {
    opacity: 0.1;
  }
}

.partner {
  background-color: #F7F7F9;
  background-image: url('../assets/images/sponsor-bg.png');
  background-size: cover;
  background-position: bottom left;

  width: var(--sponsors-card-width);
  padding: var(--sponsors-card-padding);
  margin: var(--sponsors-card-margin);

  &-logos {
    display: flex;
    flex-wrap: wrap;
    gap: 2rem;
    justify-content: space-around;

    img {
      width: var(--sponsors-card-logo-width);
      max-width: var(--sponsors-card-logo-width);
      max-height: var(--sponsors-card-logo-width);
      object-fit: contain;
    }
  }

  &-title {
    font-weight: 700;
    color: #1B1B1B;
    font-family: $ff-headings;
    font-weight: normal;
    text-transform: uppercase;
    text-align: center;
    color: $color-betano;

    font-size: var(--sponsors-card-title-size);
    margin: var(--sponsors-card-title-margin);
  }

  img {
    margin: auto;
    flex-grow: 1;
    transition: transform .2s ease-out;

    &:hover {
      // transform: scale(1.15);
    }
  }
}
</style>
